import React, { useEffect, useState } from "react";
import { t } from "i18next";

import { IBox, IBoxOptions, IBoxText } from "../../../interfaces/event/box"

import BaseToggle from "../../shared/BaseToggle";
import PageTitle from "../../shared/pageTitle/PageTitle";
import Typography from "../../shared/typography/Typography";

import { Subtitle } from "../../shared-v2/Subtitle";
import { TextActions } from "../../shared-v2/TextActions";
import { IFile, UploadImage } from "../../shared-v2/UploadImage";
import { TextArea } from "../../shared-v2/TextArea";
import { AlignActions } from "../../shared-v2/AlignActions";

import { breakpointSize } from "../../../theme/mediaQuerie";
import { Column, Main, Row, RowGrid, ToggleContainer, ActionsContainer } from './style';
import { AlignIcon } from "./AlignIcon";

interface IProps {
  box: IBox;
  setBox: React.Dispatch<React.SetStateAction<IBox>>;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const Box = ({box, setBox}: IProps) => {
  const [file, setFile] = useState<IFile | null>(null);

  useEffect(() => {
    let newBox = box.options[0];
    newBox = {...newBox, backgroundImage: file?.url}
    setBox(prev => ({...prev, options: [newBox]}));
  }, [file]);

  const updateBox = (attr: keyof IBox, value: boolean) => {
    setBox(prev => ({...prev, [attr]: value}));
  }

  const updateOptions = (attr: keyof IBoxOptions, value: string) => {
    let newBox = box.options[0];
    newBox = {...newBox, [attr]: value}
    setBox(prev => ({...prev, options: [newBox]}));
  }

  const updateText = (attr: keyof IBoxText, value: string) => {
    let newBox = box.options[0];
    newBox = {...newBox, text: {...newBox.text, [attr]: value}}
    setBox(prev => ({...prev, options: [newBox]}));
  }

  /* 
  const handleAddBox = () => {
    let options = box.options;
    options.push(newBox);
    let newState = {...box, options: options};
    setBox(newState);
    setNewBox({
      position: "left",
      text: {
        align: "center", 
        description: "",
        title: "",
      }
    });
    setFile(null);
  }
  const handleRemoveBox = (index: number) => {
    let newOptions = box.options;
    newOptions.splice(index, 1);
    let newState = {...box, options: newOptions};
    setBox(newState);
  } */

  return (
    <>
      <Row>
        { !isMobile && <PageTitle style={{margin: 0}}>{t("dashboard.event.box.title")}</PageTitle> }
        <ToggleContainer>
          <Typography type="paragraphS" color="title">{t("dashboard.event.displaySection")}</Typography>
          <BaseToggle
            initialCheck={box.menu ?? false} 
            onChange={(checked: boolean) => updateBox("menu", checked)} 
          />
        </ToggleContainer>
      </Row>

      <Column>
        <Main>
        { !isMobile ? (
          <Typography type="labelL" color="title">
            {t("dashboard.event.box.chooseModel")}
          </Typography>
        ) : (
          <div style={{display: 'flex', gap: '16px', alignItems: "center"}}>
            <Typography type="labelL" color="title">
              {t("dashboard.event.box.title")}
            </Typography> 
            <Typography type="paragraphXXS" color="title">
              {t("dashboard.event.box.chooseModel")}
            </Typography>
          </div>
        )}

          <div style={{display: 'flex', gap: '16px'}}>
            <AlignIcon selected={box.options[0].position === "right"} setSelected={() => updateOptions("position", "right")} />
            <AlignIcon rowReverse selected={box.options[0].position === "left"} setSelected={() => updateOptions("position", "left")} />
          </div>

          <Column>
            <Row>
              <Subtitle>{t("title")}</Subtitle>

              <ActionsContainer>
                <TextActions 
                  textAlign={box.options[0].text.align} 
                  setTextAlign={(value) => updateText("align", value)}
                  menuDisplayMode={!isMobile}
                />
                {!isMobile && (
                  <AlignActions 
                    menuDisplayMode
                    alignX={box.options[0].text.positionX} 
                    alignY={box.options[0].text.positionY} 
                    setAlignX={(value) => updateText("positionX", value)} 
                    setAlignY={(value) => updateText("positionY", value)} 
                  />)
                }
              </ActionsContainer>
            </Row>
            <TextArea maxLength={50} textAlign={box.options[0].text.align} onChange={(e) => updateText("title", e.target.value)} value={box.options[0].text.title} />
          </Column>
          <Column>
            <Subtitle>{t("description")}</Subtitle>
            <TextArea maxLength={50} textAlign={box.options[0].text.align} onChange={(e) => updateText("description", e.target.value)} value={box.options[0].text.description} />
            {isMobile && (
              <AlignActions
                alignX={box.options[0].text.positionX} 
                alignY={box.options[0].text.positionY} 
                setAlignX={(value) => updateText("positionX", value)} 
                setAlignY={(value) => updateText("positionY", value)} 
              />)
            }
          </Column>
          
          <RowGrid>
            <UploadImage
              file={file}
              id="box-upload-image" 
              maxImageSize={1024 * 1024 * 10} 
              setFile={setFile} 
              title={t("image")} 
            />
          </RowGrid>
{/*           <Button 
            style={{marginLeft: "auto", marginRight: "auto"}} 
            rounded 
            size="small" 
            onClick={handleAddBox}
            enable
            fullWidth={isMobile}
            variant={isMobile ? "outlined" : "contained"}
            colorBackground={isMobile ? "body" : "primary"}
            colorFont={isMobile ? "body" : "white"}
            colorHover={isMobile ? "body" : "white"}
          >
            {t("add")}
          </Button> */}
        </Main>
        {/* <SectionsList>
          {
            box.options.map( (op, index) => (
              <Card 
                customBackground="background" 
                key={index} 
                title={t("section") + " " + (index+1)} 
                onDelete={() => handleRemoveBox(index)}
              > 
                <CardContent>
                  <div style={{marginTop: '16px'}}>
                    <Typography type="headingXXS" color="title">{t("title") + ":"}</Typography>
                    <Typography type="paragraphXS" color="title">{op.text.title}</Typography>
                  </div>
                  <div>
                    <Typography type="headingXXS" color="title">{t("description") + ":"}</Typography>
                    <Typography type="paragraphXS" color="title">{op.text.description}</Typography>
                  </div>
                  <div style={{marginTop: '16px'}}>
                    <Typography type="headingXXS" color="title">{t("image") + ":"}</Typography>
                    <Typography type="paragraphXS" color="title">{op.backgroundImage}</Typography>
                  </div>
                </CardContent>
              </Card>
          ))}
        </SectionsList> */}
      </Column>
    </>
  );
}